module.exports = __webpack_public_path__ + "media/images/athletes/2019-faa588dce55ffbafb224c0b1fda9b9d1.png";